export enum DiningOptionsEnum {
  QUICK_ORDER,
  TABLE_SERVICE,
  CALL_IN_ORDER,
  OPEN_TAB
}
export enum TabType{
  DININGOPTION = 'diningOption',
  POSMODULEDISPLAY = 'posModuleDisplay',
}